<template>
  <table
    class="table b-table b-table-stacked-xs table-bordered table-sm bg-white text-uppercase"
  >
    <tbody>
      <tr>
        <th colspan="4">
          <h5 class="text-center"><b>TRABALHO E REMUNERAÇÃO</b></h5>
        </th>
      </tr>

      <tr>
        <td colspan="4">
          POSSUI QUALIFICAÇÃO PROFISSIONAL?
          <b>{{ usuario.qualificacao_profissional || '-' }}</b>
        </td>
      </tr>

      <tr>
        <td colspan="4">
          QUAL SUA PROFISSÃO DE ACORDO COM A CLASSIFICAÇÃO BRASILEIRA DE OCUPAÇÕES?
          <b>{{ profissaoNome }}</b>
        </td>
      </tr>

      <tr>
        <td colspan="2">
          NA SEMANA PASSADA TRABALHOU?
          <b>{{ usuario.trabalhou || '-' }}</b>
        </td>
        <td colspan="2">
          NESTE TRABALHO PRINCIPAL ERA:
          <b>{{ usuario.profissao_principal || '-' }}</b>
        </td>
      </tr>

      <tr>
        <td colspan="4">
          AFASTADO DE TRABALHO?
          <b>{{ usuario.afastado || '-' }}</b>
        </td>
      </tr>

      <tr>
        <td colspan="4">
          TRABALHO NA AGRICULTURA / PESCA / EXTRAÇÃO?
          <b>{{ usuario.trabalho_agricultura || '-' }}</b>
        </td>
      </tr>

      <tr>
        <td colspan="2">
          RECEBEU REMUNERAÇÃO?
          <b>{{ usuario.recebeu_remuneracao || '-' }}</b>
        </td>
        <td colspan="2">
          VALOR BRUTO RECEBIDO:
          <b>{{ usuario.valor_remuneracao || '-' }}</b>
        </td>
      </tr>

      <tr>
        <td colspan="4">
          VALOR RECEBIDO DE OUTRAS FONTES:
          <b>{{ usuario.valor_outras_fontes || '-' }}</b>
        </td>
      </tr>

      <tr>
        <td colspan="2">
          TRABALHOU NOS ÚLTIMOS 12 MESES?
          <b>{{ usuario.remuneracao_12_meses || '-' }}</b>
        </td>
        <td>
          VALOR BRUTO TOTAL:
          <b>{{ usuario.remuneracao_valor_bruto || '-' }}</b>
        </td>
        <td>
          MESES TRABALHADOS:
          <b>{{ usuario.qtd_meses_trabalhados || '-' }}</b>
        </td>
      </tr>

      <tr>
        <td colspan="2">
          APOSENTADORIA:
          <b>{{ usuario.aposentadoria_motivo || '-' }}</b>
        </td>
        <td colspan="2">
          VALOR APOSENTADORIA:
          <b>{{ usuario.aposentadoria_valor || '-' }}</b>
        </td>
      </tr>

      <tr>
        <td colspan="2">
          BENEFÍCIOS:
          <b>{{ usuario.beneficio || '-' }}</b>
        </td>
        <td colspan="2">
          VALOR BENEFÍCIO:
          <b>{{ usuario.beneficio_valor || '-' }}</b>
        </td>
      </tr>

      <tr>
        <td colspan="4">
          <b>RENDAS MENSAIS</b>
        </td>
      </tr>

      <tr>
        <td>
          DOAÇÃO
          <b>{{ usuario.doacao_valor || '-' }}</b>
        </td>
        <td>
          PENSÃO ALIMENTÍCIA
          <b>{{ usuario.pensao_alimentar_valor || '-' }}</b>
        </td>
        <td>
          SEGURO-DESEMPREGO
          <b>{{ usuario.seguro_desemprego_valor || '-' }}</b>
        </td>
        <td>
          OUTRAS RENDAS
          <b>{{ usuario.outras_rendas_valor || '-' }}</b>
        </td>
      </tr>

      <tr>
        <td colspan="4">
          TOTAL:
          <b>{{ usuario.total_rendas || '-' }}</b>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  props: ["usuario"],

  computed: {
    profissaoNome() {
      if (!this.usuario?.profissao_nome) return "-";

      const value = (this.$root.ocupacoes || []).find(
        (el) => el.id == this.usuario.profissao_nome
      );

      return value?.value || "Não encontrado";
    },
  },
};
</script>